import { FormField, TextInput } from '@percent/lemonade'
import { OpportunityFormNameFieldProps } from './opportunity-form-name-field.types'

export function OpportunityFormNameField({
  value,
  touched,
  error,
  onChange,
  onBlur,

  label,
  placeholder,
}: Readonly<OpportunityFormNameFieldProps>) {
  return (
    <FormField
      label={label}
      necessity="required"
      status={touched && error ? 'danger' : 'default'}
      statusMessage={error}
      data-testid="nameField"
    >
      <TextInput
        name="name"
        value={value}
        placeholder={placeholder}
        onBlur={onBlur}
        onChange={onChange}
        borderRadiiSize="large"
      />
    </FormField>
  )
}
